module.exports = __webpack_public_path__ + "static/media/patrycja.e8a8b538.jpg";